import { render, staticRenderFns } from "./GStoryYoutubeForm.vue?vue&type=template&id=7fc8c33e&scoped=true&"
import script from "./GStoryYoutubeForm.vue?vue&type=script&lang=ts&"
export * from "./GStoryYoutubeForm.vue?vue&type=script&lang=ts&"
import style0 from "./GStoryYoutubeForm.vue?vue&type=style&index=0&id=7fc8c33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc8c33e",
  null
  
)

export default component.exports